import { render, staticRenderFns } from "./ControlHero.vue?vue&type=template&id=493ba9bc&"
import script from "./ControlHero.vue?vue&type=script&lang=js&"
export * from "./ControlHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports